module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-client-action-buttons"
  }, [(_vm.item && _vm.canDo) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#Item-1"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, [(_vm.canApprove) ? _c('li', [_c('a', {
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("Approve")])]) : _vm._e(), (_vm.canReactivate) ? _c('li', [_c('a', {
    on: {
      "click": _vm.reactivate
    }
  }, [_vm._v("Reactivate")])]) : _vm._e(), (_vm.canSuspend) ? _c('li', [_c('a', {
    on: {
      "click": _vm.suspend
    }
  }, [_vm._v("Suspend")])]) : _vm._e(), (_vm.canDelete) ? _c('li', [_c('a', {
    on: {
      "click": _vm.deleteDriver
    }
  }, [_vm._v("Delete")])]) : _vm._e(), (_vm.canEdit) ? _c('li', [_c('a', {
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")])]) : _vm._e(), (_vm.canResetPassword) ? _c('li', [_c('a', {
    on: {
      "click": _vm.setNewPassword
    }
  }, [_vm._v("Set new Password")])]) : _vm._e(), (_vm.canSendResetPassword) ? _c('li', [_c('a', {
    on: {
      "click": _vm.sendPasswordResetEmail
    }
  }, [_vm._v("Request password reset")])]) : _vm._e(), _c('li', [_c('AddDriverFlagReveal', {
    attrs: {
      "item": _vm.entity
    }
  })], 1)])])]) : (_vm.canDo) ? _c('div', {
    staticClass: "dropdown-buttons"
  }, [(_vm.canApprove) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("Approve")]) : _vm._e(), (_vm.canReactivate) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reactivate
    }
  }, [_vm._v("Reactivate")]) : _vm._e(), (_vm.canSuspend) ? _c('button', {
    staticClass: "button warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.suspend
    }
  }, [_vm._v("Suspend")]) : _vm._e(), (_vm.canDelete) ? _c('button', {
    staticClass: "button alert",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteDriver
    }
  }, [_vm._v("Delete")]) : _vm._e()]) : (_vm.pendingDelete) ? _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.deleteClientAccount,
      "confirm": true
    }
  }, [_vm._v("Delete client account")])], 1) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('p', [_vm._v("No actions available")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac707712!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/DriverActionButtons.vue
// module id = 2657
// module chunks = 1